import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import SectionHeading from '@/components/base/SectionHeading';
import { allArticles } from '@/lib/content';

interface FeaturedSectionProps {
  excludeId?: string;
}

export default function FeaturedSection({ excludeId }: FeaturedSectionProps) {
  const list = allArticles.filter((item) => item.id !== excludeId).slice(0, 3);

  return (
    <section className="border-b border-background-200 bg-background-100 paper-grain">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading
            eyebrow="重点观察"
            title="这几件事，值得你在投简历前先看一眼"
            desc="从公开信息出发的深度整理，覆盖制度设计、组织变动与劳动关系中最常被忽略的环节。"
          />
          <Link
            to="/insight"
            className="mb-8 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 md:mb-10"
          >
            全部观察
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}